<template>
  <!--@mousemove="handleMouseMove" @mouseleave="resetZoom"-->
  <section>
    <output v-show="isDebug"
      >{{ JSON.stringify(selectedLesionDiffPostTrauma) }}
    </output>
    <svg
      width="882"
      height="785"
      viewBox="0 0 882 785"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <rect width="882" height="785" :style="zoomStyle" fill="url(#pattern3)" />
      <g :style="zoomStyle">
        <g id="brainDiff1">
          <path
            @click="selected('LeftDiffBrain')"
            :class="
              selectedLesionDiffPostTrauma.includes('LeftDiffBrain')
                ? 'selected'
                : ''
            "
            d="M88,378
                    A 2, 2, 0, 0,0 88,383
                    A 2, 2, 0, 0,0 88,378
                    Z "
            fill="#A0D6D1"
            stroke="black"
          />
        </g>
        <g id="brainDiff2">
          <path
            @click="selected('MiddleLeftDiffBrain')"
            :class="
              selectedLesionDiffPostTrauma.includes('MiddleLeftDiffBrain')
                ? 'selected'
                : ''
            "
            d="M281,350
                    A 2, 2, 0, 0,0 281,356
                    A 2, 2, 0, 0,0 281,350
                    Z "
            fill="#A0D6D1"
            stroke="black"
          />
        </g>
        <g id="brainDiff3">
          <path
            @click="selected('MiddleRightDiffBrain_upRight')"
            :class="
              selectedLesionDiffPostTrauma.includes(
                'MiddleRightDiffBrain_upRight'
              )
                ? 'selected'
                : ''
            "
            d="M429,327
                    A 2, 2, 0, 0,0 429,333
                    A 2, 2, 0, 0,0 428,327
                    Z "
            fill="#A0D6D1"
            stroke="black"
          />
          <path
            @click="selected('MiddleRightDiffBrain_bottomMiddle')"
            :class="
              selectedLesionDiffPostTrauma.includes(
                'MiddleRightDiffBrain_bottomMiddle'
              )
                ? 'selected'
                : ''
            "
            d="M415,395
                    A 2, 2, 0, 0,0 415,405
                    A 2, 2, 0, 0,0 414,395
                    Z "
            fill="#A0D6D1"
            stroke="black"
          />
          <path
            @click="selected('MiddleRightDiffBrain_middleRight')"
            :class="
              selectedLesionDiffPostTrauma.includes(
                'MiddleRightDiffBrain_middleRight'
              )
                ? 'selected'
                : ''
            "
            d="M449,373
                    A 3, 2, 0, 0,0 449,382
                    A 3, 2, 0, 0,0 448,373
                    Z "
            fill="#A0D6D1"
            stroke="black"
          />
        </g>
        <g id="brainDiff4">
          <path
            @click="selected('RightDiffBrain')"
            :class="
              selectedLesionDiffPostTrauma.includes('RightDiffBrain')
                ? 'selected'
                : ''
            "
            d="M535,340
                    A 2, 2, 0, 0,0 535,349
                    A 2, 2, 0, 0,0 534,340
                    Z "
            fill="#A0D6D1"
            stroke="black"
          />
        </g>
      </g>
    </svg>
  </section>
</template>

<script setup lang="ts">
import {
  Contexts,
  CurrentCaseServiceInterface,
  getContainer,
  getContext,
  Helpers,
  NamedBindings,
  ApplicationEvents,
  Version,
  CoreConfiguration,
} from '@dandelion/core';
import { onBeforeMount, ref, Ref } from 'vue';
import { isEqual } from 'lodash';

const props = defineProps<{
  context: string;
  fullName: string;
  id: string;
}>();

const coreConfiguration = getContainer(Contexts.DEFAULT).get(
  NamedBindings.CoreConfiguration
) as CoreConfiguration;
const currentCaseService = getContainer(Contexts.DEFAULT).get(
  NamedBindings.CurrentCaseService
) as CurrentCaseServiceInterface;

const isDebug = coreConfiguration.debug;

async function selected(selected: string) {
  const model = (await useCurrentContext(props!.context)).model;
  if (selectedLesionDiffPostTrauma.value.includes(selected)) {
    selectedLesionDiffPostTrauma.value =
      selectedLesionDiffPostTrauma.value.filter(
        (item: string) => item !== selected
      );
  } else {
    selectedLesionDiffPostTrauma.value.push(selected);
  }
  Helpers.setObjByPath(
    props.fullName,
    model,
    selectedLesionDiffPostTrauma.value
  );
}

onBeforeMount(async () => {
  const model = (await useCurrentContext(props!.context)).model;
  const selectedSeatEarlyPostProcedureFromModel = Helpers.getObjByPath(
    props.fullName,
    model
  );
  if (!selectedSeatEarlyPostProcedureFromModel) return;
  selectedLesionDiffPostTrauma.value =
    selectedSeatEarlyPostProcedureFromModel ?? [];
});

async function useCurrentContext(context = Contexts.DEFAULT) {
  let crfVersions: Readonly<Ref<ReadonlyMap<string, Version>>> = ref(new Map());
  try {
    crfVersions = ref(currentCaseService.getCrfVersions());
  } catch (e) {
    // TODO: maybe remove error thrown, there are cases when no version is available
    // e.g. the context is not set, no current patient etc.
  }

  const model = await currentCaseService.getModel();
  const keyForReRender = ref(0);

  getContext(context).addEventListener(
    ApplicationEvents.CaseOpenedForEditing,
    async () => {
      const currentCrfVersions = currentCaseService.getCrfVersions();
      if (!isEqual(currentCrfVersions, crfVersions)) {
        crfVersions = currentCrfVersions;
      }
      keyForReRender.value = keyForReRender.value + 1;
    }
  );
  return { keyForReRender, crfVersions, model };
}
const selectedLesionDiffPostTrauma = ref<Array<string>>([]);
const zoomed = ref(false);
const zoomLevel = ref(2); // Puoi modificare questo valore per cambiare il livello di zoom
const zoomStyle = ref({});

// Funzione di zoom
function handleMouseMove(event: MouseEvent) {
  const svg = (event.currentTarget as HTMLElement).querySelector('svg');
  if (!svg) return;

  const { clientX, clientY } = event;
  const svgRect = svg.getBoundingClientRect();
  const svgX = clientX - svgRect.left;
  const svgY = clientY - svgRect.top;

  // Calcolare la trasformazione per il layer di zoom
  zoomStyle.value = {
    transform: `translate(${-svgX * (zoomLevel.value - 1)}px, ${-svgY * (zoomLevel.value - 1)}px) scale(${zoomLevel.value})`,
    transformOrigin: `${svgX}px ${svgY}px`,
  };
}

function resetZoom() {
  zoomed.value = false;
  zoomStyle.value = {};
}
</script>

<style scoped>
path {
  opacity: 0.15;
}

path:hover {
  cursor: pointer;
  opacity: 0.3;
}

.selected {
  cursor: pointer;
  opacity: 0.8 !important;
}
</style>
